import type {
  MedicalAidPerson,
  MedicalAidValidationResponse,
} from '@quromedical/models';
import { CrudForm } from 'components/form';
import type React from 'react';
import { useCallback } from 'react';
import { strings } from 'strings';

import {
  createNextOfKinSelectFields,
  findMemberByDependantCode,
  type NextOfKinSelection,
} from './fields';

interface NextOfKinSelectionCardProps {
  options: MedicalAidValidationResponse;
  /**
   * A result of `other` indicates that the option selected is `other`
   */
  onSelect: (result?: Partial<MedicalAidPerson>) => void;
}

export const NextOfKinSelectionCard: React.FC<NextOfKinSelectionCardProps> = ({
  options,
  onSelect,
}) => {
  const initial: Partial<NextOfKinSelection> = {
    dependentCode: options[0]?.medicalAidMembership?.dependantCode,
  };

  const fields = createNextOfKinSelectFields(options);

  const handleChange = useCallback(
    ({ dependentCode }: Partial<NextOfKinSelection>) => {
      if (!dependentCode) {
        onSelect(undefined);
      } else {
        const found = findMemberByDependantCode(options, dependentCode);
        onSelect(found);
      }
    },
    [onSelect, options],
  );

  return (
    <CrudForm
      title={strings.FormLabelNextOfKin}
      fields={fields}
      initialValues={initial}
      showSubmitButton={false}
      onChange={handleChange}
      onChangeDebounceTime={0}
    />
  );
};
